export default __webpack_public_path__ + "locales/sr-Latn-RS/VersionHistory.json?hash=40e7da49e56872f0965d765c6e49306f";